import { Video } from "lucide-react";
import ResourceShellTemplate from "./ResourceShellTemplate";

export default function WebinarsShell() {
  return (
    <ResourceShellTemplate
      slug="webinars"
      eyebrow="Resources · Webinars"
      title="Live sessions."
      titleAccent="Real acquisition experts."
      subtitle="Monthly deep-dives on Sub-To, Novation, Wholetail, and portfolio strategies — with live Q&A and archived recordings for every session."
      icon={Video}
      previewLabel="Upcoming sessions"
      previewItems={[
        { title: "Sub-To done right: contract clauses that survive attorney review", desc: "A working session walking through the Sub-To clause library, payoff verification, and buyer routing.", meta: "Webinar · Mar 12" },
        { title: "BRRRR that actually recycles capital — refi appraisal reality check", desc: "How to underwrite BRRRR so the refi actually comes in at your target ARV. With live workspace examples.", meta: "Webinar · Mar 26" },
        { title: "Novation vs Wholesale: where the Why-Not panel changes your mind", desc: "Walk through 3 real properties where Strategy Comparison flipped the recommendation and added $28k+.", meta: "Webinar · Apr 9" },
      ]}
    />
  );
}
